import { SET_CLAIM_PROPERTY } from '../Actions/PropertyActions';
import { Property } from '../Models/Property';

interface PropertyState {
    claimProperty: {
        property: Property;
        timestamp: number;
    } | null;
}

const initialState: PropertyState = {
    claimProperty: null
};

export const propertyReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_CLAIM_PROPERTY:
            return {
                ...state,
                claimProperty: action.payload
            };
        default:
            return state;
    }
};
